module.exports = __webpack_public_path__ + "assets/img/title-c9a8e436.png";